import * as React from 'react'
import {useState, useEffect} from 'react'
import {translate} from 'react-i18next'

import {LanguageList} from '../languageList'
import * as StyledComponents from './styled'
import {GlobeIcon} from '../globeIcon'
import {LogoutIcon} from '../logoutIcon'
import {BackIcon} from '../backIcon'
import {LANGUAGES_NAME} from 'const'
import {getLang} from 'utils/stringUtils'

const Menu = ({show, toggleMenu, mobile, t, languageOptions, onLogout, isScrolling, showLogout}) => {
  const [shouldShowLanguagesList, setShouldShowLanguagesList] = useState(false)

  const handleLanguageLinkClick = event => {
    event.preventDefault()
    setShouldShowLanguagesList(!shouldShowLanguagesList)
  }

  useEffect(() => {
    if (!show) {
      setShouldShowLanguagesList(false)
    }
  }, [show])

  const handleArrowClick = () => {
    setShouldShowLanguagesList(!shouldShowLanguagesList)
  }

  const lang = getLang(window.location.search) || 'de'

  return (
    <React.Fragment>
      <StyledComponents.BarsWrapper onClick={toggleMenu} isOpen={show} isScrolling={isScrolling}>
        <span />
        <span />
        <span />
        <span />
      </StyledComponents.BarsWrapper>
      <StyledComponents.MobileView shouldShow={show}>
        {show && !!mobile && <StyledComponents.GlobalStyle />}
        {show && shouldShowLanguagesList && <BackIcon onClick={handleArrowClick} />}
        <StyledComponents.MobileContentView>
          {!shouldShowLanguagesList && (
            <>
              <StyledComponents.RouteLinksView>
                <StyledComponents.RouteLinksItem>
                  <a className="mm-next" href="#" onClick={handleLanguageLinkClick}>
                    <span>
                      <GlobeIcon />
                    </span>
                    <StyledComponents.HeaderMenuText>{LANGUAGES_NAME[lang]}</StyledComponents.HeaderMenuText>
                  </a>
                </StyledComponents.RouteLinksItem>
              </StyledComponents.RouteLinksView>
              {showLogout && (
                <>
                  <StyledComponents.RouteLinksItem className="separator" />
                  <StyledComponents.RouteLinksView className="login-route-links">
                    <StyledComponents.RouteLinksItem>
                      <a href="#" onClick={onLogout}>
                        <LogoutIcon />
                        <StyledComponents.HeaderMenuText>{t('logout')}</StyledComponents.HeaderMenuText>
                      </a>
                    </StyledComponents.RouteLinksItem>
                  </StyledComponents.RouteLinksView>
                </>
              )}
            </>
          )}
          {shouldShowLanguagesList && (
            <StyledComponents.LanguageLinksView>
              <LanguageList languageOptions={languageOptions} />
            </StyledComponents.LanguageLinksView>
          )}
        </StyledComponents.MobileContentView>
      </StyledComponents.MobileView>
    </React.Fragment>
  )
}

export default translate()(Menu)
